import { memo } from 'react';
import { Dialog } from 'react-aria-components';

import { Modal, ModalOverlay, ModalOverlayProps } from '@/components/core';

import { DeleteAgentRuns } from './DeleteAgentRuns';

export type DeleteAgentRunsModalProps = ModalOverlayProps & { agentId: string };

const IDeleteAgentRunsModal = ({ agentId, ...rest }: DeleteAgentRunsModalProps) => {
  return (
    <ModalOverlay {...rest}>
      <Modal>
        <Dialog className="outline-none">
          {({ close }) => <DeleteAgentRuns className="w-[25rem] p-4" agentId={agentId} close={close} />}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};

export const DeleteAgentRunsModal = memo(IDeleteAgentRunsModal) as typeof IDeleteAgentRunsModal;
